import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Icon from 'lqa-ui/lib/Components/Icon';
import { getItem } from '../../utils/localStorage';
import moment from 'moment';

const Container = styled('div')`
    display: flex;
    flex-direction: column;
    row-gap: 1rem;
    font-family: 'Source Sans Pro', sans-serif;
    font-style: normal;

    .text-capitalize {
        text-transform: capitalize;
    }
`;

const CardHead = styled('div')`
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    display: flex;
    justify-content: space-between;
    text-align: center;
    height: 54px;
    align-items: center;
`;

const Card = styled('div')`
    height: 80px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
`;

const MemberCard = (props) => {
  const userData = getItem('userProfile');
  const membershipCard = [
    {
      level: 'blue',
      bottomCardColor: '8298B5',
      headerColor: '071C3E',
    },
    {
      level: 'silver',
      bottomCardColor: '919191',
      headerColor: '717171',
    },
    {
      level: 'gold',
      bottomCardColor: 'F2CB15',
      headerColor: 'DEBA12',
    },
    {
      level: 'diamond',
      bottomCardColor: '717171',
      headerColor: '1F1F1F',
    },
  ];

  const [selectedMemberShip, setSelectedMemberShip] = useState<any>({
    level: 'Blue',
    bottomCardColor: '#071C3E',
    headerColor: '#8298B5',
  });

  useEffect(() => {
    const temp = membershipCard.find((item: any) => item.level === props.memberShipType);
    setSelectedMemberShip(temp);
  }, [props.memberShipType]);

  return (
    <Container>
      <div className="box-shadow">
        <CardHead className={`background-${selectedMemberShip.headerColor}`}>
          <h3 className="fw-600 f-22 lh-28 color-white ml-10 mb-0 text-capitalize">
            {selectedMemberShip.level} Member
          </h3>
          <Icon
            kind="logo"
            width={60}
            height={60}
            className="fill-white mr-10"
          />
        </CardHead>
        <Card className={`background-${selectedMemberShip.bottomCardColor}`}>
          <div className="ml-10 d-flex flex-wrap align-content-center">
            <h3 className="f-15 lh-20 color-white text-left mb-10 fw-600 w-100">
              Member since {moment(props.insertDate).format('YYYY')}
            </h3>
            <h3 className="fw-400 f-15 lh-20 color-white text-left mb-0 pb-15">
              Member: {props.membershipCode}
            </h3>
          </div>
          <div className="mr-10">
            <h3 className="fw-400 f-15 lh-20 text-right color-white mb-0 pb-15">{userData.profilePoints} Points</h3>
          </div>
        </Card>
      </div>
    </Container>
  );
};

export default MemberCard;
